module.exports = __webpack_public_path__ + "img/Skirt-Back-B7-Db-Ha.5d2c61e6.png";